// extracted by mini-css-extract-plugin
export default {"menuButton":"Menu_menuButton__bVRvg","active":"Menu_active__Hazbj"};